<template>
    <transition name="slide-fade">
        <div class="modal" :class="{'open' : open}" v-if="open">
            <div class="modal-content relative">
                <div class="bg-white w-full rounded-xl py-3 px-4">
                    <div class="flex flex-col justify-center items-center">
                        <img src="@/assets/icon/ic-gift-green.svg" alt="">
                        <div class="text-20 text-blue-1 pt-5 text-center" v-html="title"></div>
                        <div class="text-22 text-gray-1 pt-3 text-center" v-html="lbl.profile.mobile_number.input_number_text"></div>
                        <div class="text-22 text-blue-1 pt-2 text-center pb-4" v-html="mobile"></div>

                        <InputTextChangeNumber
                            v-model:inputValue="newNumber"
                            :minLength="12"
                            :maxLength="12"
                            delimeter="-"
                            :errorInfo="errorInfo[0]"
                            :isSubmitted="true"
                            :isShowError="true"
                            :inputLbl="lbl.profile.mobile_number"
                            @input="onValidateNumber()"
                        >
                        </InputTextChangeNumber>
                        <div class="w-full flex justify-center items-center border rounded-full "
                             :class="[getOtpBtnClass(isDisableOtp)]"
                        >
                            <button
                                class="w-full text-white text-22 py-2 font-bold btn-size"
                                :disabled="isDisableOtp"
                                @click="clickChangeNumber()">
                                {{lbl.profile.otp.request_otp}}
                            </button>
                        </div>

                        <div class="flex flex-col justify-center items-center" v-if="isShowOtpData">
                            <div class="text-red-1 text-20 pt-4">{{lbl.profile.otp.time_left}}{{timeLeft}}</div>
                            <div class="text-blue-1 text-20 pt-4">{{lbl.profile.otp.refcode_lbl}}{{refCode}}</div>
                        </div>
                        <div class="flex flex-col justify-center items-center" v-if="isShowErrorMsg">
                            <div class="text-red-1 text-20 pt-4" v-html="errorMsg"></div>
                        </div>
                        <div class="flex flex-col justify-center items-center" v-if="isOtpExpire">
                            <div class="text-red-1 text-20 pt-4" v-html="lbl.profile.otp.time_left_text"></div>
                        </div>

                        <div class="divider bg-gray-2 w-full my-5"></div>
                        <div class="w-full">
                            <Otp
                                ref="otp_input"
                                v-model:inputValid="isOtpValid"
                                v-model:inputOtp="otp"
                                :maxLength="6"
                                :isSubmitted="true"
                                :isShowError="true"
                                :errorInfo="errorInfo[1]"
                                :inputLbl="lbl.profile.otp"
                                :invalidOtp="invalidOtp"
                            >
                            </Otp>
                        </div>
                        <div class="w-full flex justify-center items-center border rounded-full  mb-5"
                            :class="[getConfirmBtnClass(isDisableConfirm)]">
                            <button
                                :disabled="isDisableConfirm"
                                class="w-full text-white text-22 py-2 font-bold btn-size"
                                @click="clickConfirm()"
                            >
                                ตกลง
                            </button>
                        </div>
                    </div>
                </div>
                <div class="w-9 h-9 circle-position" @click="closeModal()">
                    <img class="w-full h-full" src="@/assets/icon/ic-close-circle.svg" alt="">
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition>
</template>
<script>
import Util from "@/helper/Utility.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
import TimerHelper from "@/helper/TimerHelper.js";
// helper
import { FormHelper } from '@/helper/FormHelper.js';
import InputTextChangeNumber from "@/components/Input/label/InputTextChangeNumber.vue";
import Otp from "@/components/Authen/Otp/Otp.vue";
// service
import SPlusProfile from '@/core/Account/service/SPlusProfile.js'
// mixin
import AuthStatusMixin from '@/mixin/AuthStatusMixin';

export default {
    name: "AlertModal",
    mixins: [LocaleMixin, AuthStatusMixin],
    props: {
        controller: Object,
    },
    components: {
        InputTextChangeNumber,
        Otp
    },
    computed: {
        isValid: function () {
            return this.isOtpValid && !this.isOtpExpire;
        }
    },
    data: function () {
        return {
            open: false,
            title: "",
            mobile: "",
            message: "",
            btnOk: "",
            userInfo: null,
            busModal: null,

            newNumber: "",
            formUserInfo: null,

            otp: "",
            refCode: "",
            timeLeft: "",

            errorMsg: "",

            isOtpExpire: false,
            isOtpValid: false,
            timeHelper: new TimerHelper(),
            invalidOtp: "",

            isShowOtpData: false,
            isShowErrorMsg: false,
            isShowExpire: false,

            formValid: false,
            errorInfo: FormHelper.genErrorInfo(2),

            isDisableOtp: true,
            isDisableConfirm: true,
        };
    },
    created: function () {
        this.busModal = this.controller.busModal;
        this.isShowOtpData = false;
        this.isShowErrorMsg  = false;
        this.isShowExpire =  false;
        this.formUserInfo = this.profileCustom;
        this.invalidOtp = "";
    },
    watch: {
        otp: function (otp) {
            if (otp.length < 6) this.invalidOtp = '';
            if (otp.length == 6 && this.newNumber.length == 10) {
                this.isDisableConfirm = false
            } else {
                this.isDisableConfirm = true
            }
        }
    },
    mounted: function () {
        this.busModal.on("show", this.show);
        this.busModal.on("hide", this.hide);
    },
    methods: {
        getOtpBtnClass: function (isDisableOtp) {
            if (isDisableOtp) {
                return 'bg-a-gray-c6c6c6';
            } else {
                return 'bg-green-1';
            }
        },
        getConfirmBtnClass: function (isDisableConfirm) {
            if (isDisableConfirm) {
                return 'bg-a-gray-c6c6c6';
            } else {
                return 'bg-green-1';
            }
        },
        onValidateNumber: function () {
            if (this.newNumber.length == 10) {
                this.isDisableOtp = false;
            } else {
                this.isDisableOtp = true;
            }
        },
        show: function (config) {
            this.title = config.title;
            this.mobile = this.displayPhoneFormat(config.mobile);
            this.message = config.msg;
            this.userInfo = config.userInfo;
            this.btnOk = config.btnOk;
            if (Util.isEmptyStr(this.btnOk)) {
                this.btnOk = this.lbl.button.ok;
            }
            document.body.classList.add("not-scroll");
            this.open = true;
        },
        hide: function () {
            this.timeHelper.stopTimer();
            this.timeHelper.resetTimer();
            document.body.classList.remove("not-scroll");
            this.clearModal();
            this.open = false;
        },
        closeModal: function () {
            this.clearModal();
            this.hide();
        },
        clearModal: function () {
            this.isShowOtpData = false;
            this.isShowErrorMsg = false;
            this.isOtpExpire = false;
            this.errorMsg = '';
            this.newNumber = "";
            this.otp = "";
            this.invalidOtp = "";
            this.isDisableOtp = true;
            this.isDisableConfirm = true;
        },
        displayPhoneFormat: function(mobile){
            let phone = Util.contactNumberFormat(mobile, '-');

            return phone;
        },
        clickChangeNumber:async function () {
            await this.checkDuplicate();

        },
        requestOtp: function () {
            return new Promise((resolve) => {
                let contactNumber = this.newNumber;
                SPlusProfile.requestOtp(contactNumber, null).subscribe({
                    next: (data) => {
                        console.log(data);
                        this.refCode = data.refcode;
                        this.timeHelper.initialTimer(180, ':', false, false);
                        this.timeHelper.runTimer((timeLeft) => {
                            this.timeLeft = timeLeft;
                        }, () => {
                            this.setTimeout();
                        });
                        this.isShowErrorMsg = false;
                        this.isOtpExpire = false;
                        this.isDisableOtp = true;
                        this.isShowOtpData = true;
                        resolve(true);
                    },
                    error: (err) => {

                        resolve(false);
                        this.errorApi(err);
                    },
                });
            });
        },
        checkDuplicate: function() {
            return new Promise((resolve) => {
                let contactNumber = this.newNumber;
                SPlusProfile.checkDuplicate(contactNumber).subscribe({
                    next: (data) => {
                        console.log(data);
                        this.refCode = data.refcode;
                        this.timeHelper.initialTimer(180, ':', false, false);
                        this.timeHelper.runTimer((timeLeft) => {
                            this.timeLeft = timeLeft;
                        }, () => {
                            this.setTimeout();
                        });
                        this.isShowErrorMsg = false;
                        this.isOtpExpire = false;
                        this.isDisableOtp = true;
                        this.isShowOtpData = true;
                        resolve(true);
                    },
                    error: (err) => {
                        let msg = err.message.split("|")
                        if (err.id == 409 && msg[1] == 'Data Duplicate (Mobile)') {
                            this.errorMsg = this.lbl.profile.error.error409;
                            this.isOtpExpire = false;
                            this.isShowOtpData = false;
                            this.isShowErrorMsg = true;
                        }
                        this.controller.sendCallbackError();
                        resolve(false);
                    },
                });
            });
        },
        clickConfirm:async function() {
            if (!this.isValid) {
                console.log('not valid');
                return;
            }

            const otpData = {
                otp: this.otp,
                change_contact_number: this.newNumber,
                refcode: this.refCode,
            }

            const otpConfig = {
                ...this.userInfo,
               ...otpData,
            }

            let success = await this.sendUpdateNumber(otpData);
            if (success) {
                this.controller.sendCallbackOk(otpConfig);
                this.clearModal();
            }

        },
        setTimeout: function() {
            this.timeHelper.stopTimer();
            this.timeHelper.resetTimer();
            this.isShowErrorMsg = false;
            this.isShowOtpData = false
            this.isOtpExpire = true;
            this.isDisableOtp = false;
        },
        sendUpdateNumber:async function(objData) {
            let userData = this.formUserInfo.getParams();
            userData = {
                ...userData,
                change_contact_number: objData.change_contact_number,
                otp: objData.otp,
                refcode: objData.refcode,
            }

            return new Promise((resolve) => {
                SPlusProfile.UpdateNumber(userData).subscribe({
                    next: (data) => {
                        console.log(data);
                        resolve(true);
                    },
                    error: (err) => {
                        console.log(err);
                        if( err.code == 409 ) {
                            this.invalidOtp = err.message;
                        }
                        resolve(false);
                    }
                });
            });
        },
    },

}
</script>
<style lang="scss" scoped>
    @import "@/style/modal.scss";
    .modal {
        @extend %modal;

        &.open {
            overflow: auto;
        }

        .modal-content {
            overflow: unset;
        }
        .divider {
            height: 1px;
        }
        .circle-position {
            position: absolute;
            left: 50%;
            transform: translate(-50%, -50%);
        }
        .btn-size {
            height: 45px;
        }
    }
</style>
